import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/Rx';

import { MigalhasService } from 'app/shared/migalhas/migalhas.service';

import { Migalha } from 'models/migalha';
import { environment } from 'environments/environment';
import { CalendarioService } from 'app/shared/calendario-service.service';

@Component({
  selector: 'app-graduacao',
  templateUrl: './graduacao.component.html',
  styleUrls: ['./graduacao.component.scss'],
})
export class GraduacaoComponent implements OnDestroy {

  url: BehaviorSubject<string> = new BehaviorSubject<string>('');
  routerObserver;
  migalhas: Migalha[];
  shouldHaveSideMenu: Boolean = true;
  migalhasObs;

  baseMenuLateral = {
    nome: 'Graduação',
    link: '',
  };

  menuLateral = []

  constructor(
    private router: Router,
    private migalhasService: MigalhasService,
    private calendarioService: CalendarioService
  ) {

    if (environment.loginContexto === 'CEUMA') {
      this.menuLateral = [
        {
          nome: 'Lista de Cursos',
          link: '/graduacao',
          submenu: [
            { nome: 'Humanas', link: '/graduacao/humanas' },
            { nome: 'Exatas', link: '/graduacao/exatas' },
            { nome: 'Saúde', link: '/graduacao/saude' },
          ],
        },
        {
          nome: 'Enade',
          link: '/graduacao/enade',
          submenu: [],
        },
        {
          nome: 'Condições de Oferta de Curso',
          link: '/graduacao/condicoes-oferta-curso',
          submenu: [],
        },
        {
          nome: 'Consulta de Formados',
          link: '/graduacao/valida-documentos',
          submenu: [],
        },
        {
          nome: 'Consulta de E-mail',
          link: '/graduacao/consulta-email',
          submenu: [],
        },
        {
          nome: 'Fies/Prouni',
          link: '/graduacao/fies-prouni',
          submenu: [],
        }
      ];
    } else {
      this.menuLateral = [
        {
          nome: 'Lista de Cursos',
          link: '/graduacao',
          submenu: [
            { nome: 'Humanas', link: '/graduacao/humanas' },
            { nome: 'Exatas', link: '/graduacao/exatas' },
            { nome: 'Saúde', link: '/graduacao/saude' },
          ],
        },
        {
          nome: 'Enade',
          link: '/graduacao/enade',
          submenu: [],
        },
        (environment.loginContexto!='FAMAZ') ? {
          nome: 'Condições de Oferta de Curso',
          link: '/graduacao/condicoes-oferta-curso',
          submenu: [],
        } :
        {
          nome: '',
          link: '',
          submenu: [],
        },
        {
          nome: 'Consulta de Formados',
          link: '/graduacao/valida-documentos',
          submenu: [],
        },
        (environment.loginContexto!='FAMAZ') ? {
          nome: 'Consulta de E-mail',
          link: '/graduacao/consulta-email',
          submenu: [],
        } :
        {
          nome: '',
          link: '',
          submenu: [],
        }
      ];
    }

    const migalhaRaiz = new Migalha(this.baseMenuLateral);
    migalhaRaiz.submenu = Migalha.construirArray(this.menuLateral);

    this.migalhasObs = this.migalhasService
      .iniciar([migalhaRaiz])
      .subscribe((dados) => {
        this.migalhas = dados;
      });

    let url = '';
    this.routerObserver = router.events.subscribe((evento) => {
      if (evento instanceof NavigationEnd) {
        url = evento.url;
        this.url.next(url);
        this.migalhasService.novaUrl(url);
        this.shouldHaveSideMenu = this.updateShowSideMenu(url);
      }
    });
    this.url = new BehaviorSubject<string>(url);
  }

  ngOnDestroy() {
    if (this.routerObserver) {
      this.routerObserver.unsubscribe();
    }

    if (this.migalhasObs) {
      this.migalhasObs.unsubscribe();
    }
  }

  private updateShowSideMenu(url: String) {
    return this.menuLateral.some(item => this.findLinkOnItemMenu(item, url));
  }

  private findLinkOnItemMenu(item, url) {
    if (item.link === url) {
      return true;
    } else if (item.submenu && item.submenu.length) {
      return item.submenu.some(itemSubmenu => this.findLinkOnItemMenu(itemSubmenu, url));
    }
    return false;
  }

}
